/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientRiskMatrixResultsRequestDto } from '../../models/client-risk-matrix-results-request-dto';
import { ClientRiskMatrixResultsResponseDto } from '../../models/client-risk-matrix-results-response-dto';

export interface SaveRiskResults$Params {
      body: ClientRiskMatrixResultsRequestDto
}

export function saveRiskResults(http: HttpClient, rootUrl: string, params: SaveRiskResults$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientRiskMatrixResultsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, saveRiskResults.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientRiskMatrixResultsResponseDto>;
    })
  );
}

saveRiskResults.PATH = '/kyc/client-risk-matrix/results';
